module.exports = __webpack_public_path__ + "files/0f55e5fa94c78f967675ef24b73499d0.png";